import React from "react";
import { Box, List, ListItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const SidebarContainer = styled(Box)(({ theme }) => ({
  width: 200,
  backgroundColor: "#202020",
  height: "95%",
  position: "fixed",
  left: `calc(${theme.spacing(9)} + 1px)`,
  display: "flex",
  flexDirection: "column",
  zIndex: 10,

  variants: [
    {
      props: {
        draweropen: "true",
      },

      style: {
        left: `calc(264px + 1px)`,
      },
    },
  ],
}));

const SidebarItem = styled(ListItem)(({ theme, active }) => ({
  width: "auto",
  color: "#A0A0A0",
  cursor: "pointer",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#121212",
  },
  borderLeft:
    active === "true"
      ? `4px solid ${theme.custom.brandColor}`
      : "4px solid black",
  paddingLeft: active === "true" ? "8px" : "12px",
  margin: "0px 16px ",
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  variants: [
    {
      props: {
        active: "true",
      },

      style: {
        backgroundColor: "#121212",
      },
    },
    {
      props: {
        active: "true",
      },

      style: {
        borderLeft: `4px solid ${theme.custom.brandColor}`,
      },
    },
    {
      props: {
        active: "true",
      },

      style: {
        paddingLeft: "8px",
      },
    },
  ],
}));

const SidebarText = styled(Typography)(() => ({
  color: "#9E9FA1",
  fontSize: 14,
  fontWeight: 500,
  marginLeft: 8,
}));

const SecondarySection = styled(Box)({
  marginTop: "auto",
  marginBottom: 32,
});

export default function ProjectSidebar({ drawerOpen, setEditModalOpen }) {
  const history = useHistory();
  const { pathname } = useLocation();
  const projectId = pathname.split("/")[3];
  const reducer = useSelector((reducer) => reducer);

  const {
    AccountReducer: { selectedAccount },
  } = reducer;

  const menuItems = [
    // {
    //   id: "dashboard",
    //   text: "Project Dashboard",
    //   to: `/account/project/${projectId}/dashboard`,
    // },
    {
      id: "agents",
      text: "Agents",
      to: `/account/project/${projectId}/agents`,
    },
    {
      id: "audience",
      text: "Audience",
      to: `/account/project/${projectId}/audiences`,
    },
    {
      id: "campaigns",
      text: "Campaigns",
      to: `/account/project/${projectId}/campaigns`,
    },

    ...(selectedAccount?.params?.multiAgent
      ? [
          {
            id: "multi-agents",
            text: "Multi Agent",
            to: `/account/project/${projectId}/multi-agents`,
          },
        ]
      : []),
    ...(selectedAccount?.params?.multiAgent
      ? [
          {
            id: "threads",
            text: "Threads",
            to: `/account/project/${projectId}/threads`,
          },
        ]
      : []),
    ...(selectedAccount?.params?.botsKnowledge
      ? [
          {
            id: "ragUpload",
            text: "Bot's Knowledge",
            to: `/account/project/${projectId}/rag-upload`,
          },
        ]
      : []),
  ];

  const secondaryMenu = [
    {
      id: "call_settings",
      text: "Call settings",
      to: `/account/project/${projectId}/call-settings`,
    },
    ...(selectedAccount?.params?.multiAgent
      ? [
          {
            id: "gmail-integration",
            text: "Integration",
            to: `/account/project/${projectId}/integrations`,
          },
        ]
      : []),
    {
      id: "messaging",
      text: "Messaging",
      to: `/account/project/${projectId}/common`,
    },
  ];
  const secondaryMenuItems = selectedAccount?.params?.dialerConfig
    ? [
        ...secondaryMenu,
        {
          id: "dialer_config",
          text: "Dialer config",
          to: `/account/project/${projectId}/dialer-config`,
        },
      ]
    : secondaryMenu;

  const isActive = (itemPath) => {
    if (pathname === itemPath) return true;
    if (pathname.includes("/leads")) {
      return itemPath.includes("/integrations");
    }

    if (
      pathname.includes("/campaign") ||
      pathname.includes("/schedule-campaign") ||
      pathname.includes("/all-runs-details")
    ) {
      return itemPath.includes("/campaigns");
    }

    if (pathname.includes("/threads")) {
      return itemPath.includes("/threads");
    }
    if (
      pathname.includes("/call-settings") ||
      pathname.includes("/call-settings-functions")
    ) {
      return itemPath.includes("/call-settings");
    }

    return false;
  };

  return (
    <SidebarContainer draweropen={drawerOpen}>
      <List>
        {menuItems.map((item) => (
          <SidebarItem
            key={item.id}
            onClick={() => {
              history.push(item.to);
              setEditModalOpen(false);
            }}
            active={isActive(item.to).toString()}
          >
            <Box className="flex-align-center">
              <SidebarText>{item.text}</SidebarText>
            </Box>
          </SidebarItem>
        ))}
      </List>

      <SecondarySection>
        <Typography
          className="font-14-lightgrey"
          sx={{
            ml: 2,
          }}
        >
          Project settings
        </Typography>
        <List>
          {secondaryMenuItems.map((item) => (
            <SidebarItem
              key={item.id}
              onClick={() => {
                history.push(item.to);
                setEditModalOpen(false);
              }}
              active={isActive(item.to).toString()}
            >
              <Box className="flex-align-center">
                <SidebarText>{item.text}</SidebarText>
              </Box>
            </SidebarItem>
          ))}
        </List>
      </SecondarySection>
    </SidebarContainer>
  );
}
